import { useState, useMemo } from "react";
import { MdGridView, MdFormatListBulleted } from "react-icons/md";

import "./style.scss";

export const VIEW_TYPES = {
  LIST: "LIST",
  GRID: "GRID"
};

export default function Listable(props) {
  const {
    title,
    className = "",
    // toolbarConfig,
    listItems = [],
    views = {}
  } = props;

  const [viewType, setViewType] = useState(props.defaultViewType || VIEW_TYPES.LIST);

  const toggleViewButtonIcon = useMemo(() => {
    let text = "";
    let targetViewType = VIEW_TYPES.LIST;
    switch (viewType) {
      case VIEW_TYPES.LIST:
        text = <MdGridView />
        targetViewType = VIEW_TYPES.GRID;
        break;
      case VIEW_TYPES.GRID:
        text = <MdFormatListBulleted />
        targetViewType = VIEW_TYPES.LIST;
        break;
      default: break;
    }
    return <button className="view-toggle centered pointer card clickable" onClick={() => setViewType(targetViewType)}>{text}</button>
  }, [viewType]);

  return (
    <div className={`Listable ${className}`}>
      <div className="flex-row flex-between">
        <h2>{title}</h2>
        <div className="toolbar">
          {toggleViewButtonIcon}
        </div>
      </div>

      {viewType === VIEW_TYPES.GRID && (
      <div className="m-t-md flex-row flex-gap-lg flex-wrap item-list">
          {listItems?.map((data, index) => (
            <div className="card mobile-w-100pc clickable" key={index}>
              {views[VIEW_TYPES.GRID](data)}
            </div>
          ))}
        </div>
      )}

      {viewType === VIEW_TYPES.LIST && (
        <div className="m-t-md flex-column flex-gap-lg item-list">
          {listItems?.map((data, index) => (
            <div className="card clickable" key={index}>
              {views[VIEW_TYPES.LIST](data)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}